import { render, staticRenderFns } from "./collectNews.vue?vue&type=template&id=450a8454&scoped=true&"
import script from "./collectNews.vue?vue&type=script&lang=js&"
export * from "./collectNews.vue?vue&type=script&lang=js&"
import style0 from "./collectNews.vue?vue&type=style&index=0&id=450a8454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a8454",
  null
  
)

export default component.exports